import React from "react";
import { cn } from "../../../common/u1/cn";
import { addressFields, industryActivities } from "./profileStatus";
import {
  ProfileCard,
  ProfileField,
  IndustryActivities,
  AddressCard,
  AboutCompany,
} from "./ProfilePrimitives";

/* Tab 01 — General Information. */

/* All of these live in ProfilePrimitives — Business Details needs the two shapes, and GatedTabPreview needs the three cards for its locked-tab placeholder. */
export { ProfileCard, ProfileField, IndustryActivities, AddressCard, AboutCompany };

export const GeneralInformation = ({ company, trevexId }) => {
  const activities = industryActivities(company);
  const address = addressFields(company, trevexId);

  return (
    <div className="flex flex-col gap-[22px]">
      <IndustryActivities activities={activities} />

      {/* Address and About sit side by side above `lg`, as the design pairs
          them; either one alone takes the full width. */}
      <div className="grid grid-cols-1 items-start gap-[22px] lg:grid-cols-2">
        <AddressCard address={address} />
        <AboutCompany description={company?.company_description} />
      </div>
    </div>
  );
};

export default GeneralInformation;
